import CreditMemoItem from '../../Domain/CreditMemo/CreditMemoItem';
import SearchParams from '../../Elements/SearchParams';
import CreditMemoSearchParams from '../../Contents/Operations/CreditMemo/CreditMemoSearchParams';
import AuthService from '../authService';

export default class CreditMemoService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const authService = AuthService.getInstance();

    let url = '/api/CreditMemo/GetBySearchParams/?';

    const searchParams = new SearchParams(searchItem, CreditMemoSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    url += `searchParams=${searchParams.serializeForBackendCall()}`;
    url += `&clearCache=${clearCache}`;

    return authService.CallBackendFunction(url);
  }

  static GetById(id) {
    const authService = AuthService.getInstance();
    const url = `/api/CreditMemo/GetByIdAsync/${id}`;
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new CreditMemoItem(item));
    }
    return [];
  }

  static GetInvoiceById(item) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/CreditMemo/GetInvoiceById?&searchItem=${JSON.stringify(item)}`
    );
  }

  static AttachReportAsync(id) {
    const url = `/api/CreditMemo/AttachReportAsync/${id}`;

    return AuthService.getInstance().CallBackendFunctionPut(url);
  }
}
